// types.ts
export enum OpenJobsModals {
  REPORT_PREPARING = 'report-preparing',
}
